module.exports = __webpack_public_path__ + "static/media/Zip_Icon.ee99dc1a.svg";